import { Breadcrumbs } from '@dustin-web/microsite-components/src/breadcrumbs'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'

type Props = {
  displayName?: string
}

const AccessoryGuideBreadcrumbs = ({ displayName }: Props) => {
  const { translate } = useTranslations()

  const breadcrumbs = [
    {
      displayName: translate('Products'),
      url: translate('AllCategories_URL'),
      clientNavigationRoute: '',
    },
    {
      displayName: translate('AccessoryGuides_Title'),
      url: displayName ? '/accessories/guides' : '',
      clientNavigationRoute: '',
    },
    ...(displayName
      ? [
          {
            displayName,
            url: '',
            clientNavigationRoute: '',
          },
        ]
      : []),
  ]
  return <Breadcrumbs path={breadcrumbs} />
}

export default AccessoryGuideBreadcrumbs
